import React from 'react';
import {FaTwitter,FaFacebook,FaInstagram} from 'react-icons/fa'
const Footer =()=>{
     return (
    <div className='flex justify-center bg-black w-[100%] h-[200px]'>
        <div>
            <h1 className='text-3xl font-bold text-[#E5038B] text-center'>Hritik
            </h1>
            <p className='py-4 text-white'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem tenetur, praesentium autem quis reiciendis accusantium in reprehenderit officia vitae ex.</p>
            <div className='flex justify-evenly'>
                <FaFacebook size={30} className="bg-white rounded-[50%]"/>
                <FaInstagram size={30}  className="bg-white rounded-[50%]"/>
                <FaTwitter size={30} className="bg-white rounded-[50%]"/>
            </div>
        </div>
        
           
    </div>
  )

}
 

export default Footer